export const MAGIC_EDEN_BASE = "magic-eden";
export const NFT = `${MAGIC_EDEN_BASE}/nft`;
export const COLLECTION = `${MAGIC_EDEN_BASE}/collection`;
export const BUY_NOW = `${MAGIC_EDEN_BASE}/buy-now`;
export const SELL = `${MAGIC_EDEN_BASE}/sell`;
export const CANCEL = "cancel";
export const DISTRIBUTE = "distribute";
export const RETRY = "retry";
export const ACTIVITIES = "activities";
